module.exports = __webpack_public_path__ + "static/SQUARE_orange-c8a80c742cf019dc03d7cf1b87e05825.jpeg";